// For some reason, AddToCartBar needs to be imported after ProductInfo
// otherwise, we get a warning
// eslint-disable-next-line simple-import-sort/imports
import {
  getNavIdFromTitle,
  GridCol,
  GridContainer,
  GridRow,
  useIsWindowBiggerThan,
} from '@bob/library'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import { breakpoints, styles } from 'leds'
import React, { useRef, useState } from 'react'

import { ProductInfo } from './ProductInfo/ProductInfo'
import { AddToCartBar } from './ProductInfo/AddToCartBar/AddToCartBar'
import { ImageGrid } from './ProductInfo/ImageGrid/ImageGrid'

import * as SC from './ProductPageDetails.style'

export interface ProductPageDetailsProps {
  productDetails: ReturnType<typeof mapProductPage>['product_details']
  warnings: string[]
  isTopOfPage?: boolean
}

export function ProductPageDetails({
  productDetails,
  warnings,
  isTopOfPage,
}: ProductPageDetailsProps) {
  const infoRef = useRef<HTMLDivElement | null>(null)
  const [quantity, setQuantity] = useState<number>(1)

  const addToCartButtonRef = useRef<HTMLButtonElement>(null)
  const id = productDetails.caption ? getNavIdFromTitle(productDetails.caption) : undefined

  const isScreenMedium = useIsWindowBiggerThan(breakpoints.m, true)

  return (
    <>
      <AddToCartBar
        addToCartButtonRef={addToCartButtonRef}
        productDetails={productDetails}
        quantity={quantity}
      />

      <GridContainer>
        <SC.Wrapper>
          <GridRow id={id}>
            {isScreenMedium && (
              <GridCol
                as={'section'}
                className={styles({
                  marginTop: { screenXS: 25, screenM: 0 },
                })}
                desktop={6}
                giant={6}
                tablet={6}
                veryGiant={6}
              >
                <ImageGrid assets={productDetails.assets} />
              </GridCol>
            )}
            <GridCol desktop={6} giant={6} tablet={6} veryGiant={6}>
              <ProductInfo
                addToCartButtonRef={addToCartButtonRef}
                isTopOfPage={isTopOfPage}
                productDetails={productDetails}
                quantity={quantity}
                setQuantity={setQuantity}
                warnings={warnings}
                withCarousel={!isScreenMedium}
                wrapperRef={infoRef}
              />
            </GridCol>
          </GridRow>
        </SC.Wrapper>
      </GridContainer>
    </>
  )
}
